import config from '@/configs'
import moment from "moment"
import { currency } from "@/commons/currency";
import { sendErrorNotice, refreshResource } from '@/commons/utils';

export function request_header(token) {
  return {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "accept": "application/json",
  };
}

export function request_payload(param) {
  let query = '';
  let q_params = [];
  if(param && (param.pagination || param.qObject || param.filter || param.quickFilter)) {
    const page = param.pagination && param.pagination.page ? param.pagination.page : 1
    const rowsPerPage = param.pagination && param.pagination.itemsPerPage ? param.pagination.itemsPerPage : 1000000
    const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
    const descending = param.pagination ? param.pagination.sortDesc[0] : 1
    const qObject = param.qObject ? Buffer.from(JSON.stringify({ qObject: param.qObject })).toString("base64") : '';
    const filter = param.filter && param.filter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.filter })).toString("base64") : '';
    const quickFilter = param.quickFilter && param.quickFilter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.quickFilter })).toString("base64") : '';
    q_params.push(`filter=${encodeURIComponent(filter)}&qObject=${encodeURIComponent(qObject)}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}&q=${encodeURIComponent(quickFilter)}`)
  }

  if(param) {
    var fields = []
    Object.keys(param).forEach((key) => {
      if(!['pagination', 'qObject', 'filter', 'quickFilter', 'fields'].includes(key)) {
        fields.push(`${key}=${param[key] == null ? '' : param[key]}`)
      }
      else if(key == 'fields') {
        fields.push(`${key}=${param[key] == null ? '' : param[key].join(',')}`)
      }
    });
    q_params.push(`${fields.join('&')}`);
  }
  query = `?${q_params.join('&')}`;
  return query;
}

export function upload_file(endpoint, cb, $http, param, token, func) {
  const header = {
    headers: request_header(token),
    responseType: 'blob'
  };
  header.headers['Content-Type'] = 'multipart/form-data';
  func = func ? func : 'import'

  $http.post(`${config.API}/api/${endpoint}/${func}/`, param, header).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function request_list(endpoint, cb, $http, param, token) {
  const req = {
    headers: request_header(token)
  };
  
  const query = request_payload(param);

  $http.get(`${config.API}/api/${endpoint}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
  });
}

export function request_detail(endpoint, cb, $http, id, token, param) {
  const header = {
    headers: request_header(token)
  };
  let query = '';
  if(param) {
    if(param.pagination) {
      const page = param.pagination ? param.pagination.page : 1
      const rowsPerPage = param.pagination ? param.pagination.itemsPerPage : 1000000
      const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
      const descending = param.pagination ? param.pagination.sortDesc[0] : 1
      query = `?page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}`;
      delete param.pagination;
    }
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = query == '' ? `?${fields.join('&')}` : `${query}&${fields.join('&')}`;
  }
  $http.get(`${config.API}/api/${endpoint}/${id}${query}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
  });
}

export function update_detail(endpoint, cb, $http, param, pId, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  let path = pId == 0 ? `${config.API}/api/${endpoint}/` : `${config.API}/api/${endpoint}/${pId}`;
  $http.post(path, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
    }
  });
}

export function remove_detail(endpoint, cb, $http, id, token) {
  const header = {
    headers: request_header(token)
  };
  $http.delete(`${config.API}/api/${endpoint}/${id}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
      refreshResource();
    }
  });
}

export function create_detail(endpoint, cb, $http, param, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  delete req['ID'];
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  $http.put(`${config.API}/api/${endpoint}/`, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
    }
  });
}

export function export_list(endpoint, cb, $http, param, token, func, errorCb) {
  const req = {
    headers: request_header(token),
    responseType: 'blob'
  };
  func = func ? func : 'export'
  const query = request_payload(param)

  $http.get(`${config.API}/api/${endpoint}/${func}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res), 100);
  }).catch(function (error) {
    console.error('Export error:', error);
    if (errorCb) {
      errorCb(error);
    } else {
      sendErrorNotice('Lỗi khi xuất file!');
    }
  });
}

export function export_detail(endpoint, cb, $http, id, token, func, errorCb) {
  const req = {
    headers: request_header(token),
    responseType: 'blob'
  };
  func = func ? func : 'export'

  $http.get(`${config.API}/api/${endpoint}/${func}/${id}`, req).then(function (res) {
    setTimeout(() => cb(res), 100);
  }).catch(function (error) {
    console.error('Export error:', error);
    if (errorCb) {
      errorCb(error);
    } else {
      sendErrorNotice('Lỗi khi xuất file!');
    }
  });
}

export function comment_type(value) {
  const cmtType = config.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.name : '';
}

export function comment_type_color(value) {
  const cmtType = config.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.color : '#e6c87f';
}

export function comment_avatar(value) {
  if (value !== null) {
    return '/static/avatar/avatar.png';
  }
  return '/static/avatar/no_avatar.png';
}

export function comment_color(value) {
  if (value) {
    return '#ff0000';
  }
  return '#0000ff';
}

export function payment_type(value) {
  switch (value) {
    case 2:
    case 3:
      return "Đặt cọc";
    case 12:
      return "Hoàn tiền"
    default:
      return "Thanh toán";
  }
}

export function payment_type_color(value) {
  switch (value) {
    case 2:
      return "#e6c87f";
    case 3:
      return "#ffff00";
    case 12:
      return "#ff0000"
    default:
      return "#0000ff";
  }
}

export function complain_type(value) {
  switch (value) {
    case 1:
      return "Chờ xử lý";
    case 2:
      return "Đang xử lý";
    case 3:
      return "Đã xử lý"
    default:
      return "Đã hủy";
  }
}

export function complain_type_color(value) {
  switch (value) {
    case 1:
      return "#ff0000";
    case 2:
      return "#797960";
    case 3:
      return "#0000ff"
    default:
      return "#e6c87f";
  }
}

export function trade_type(value) {
  const cmtType = config.TRADE_TYPE.find(obj => obj.value === value);
  return cmtType ? cmtType.name : '';
}

function escape_label_html(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function normalize_label_count(value) {
  const parsedValue = Number(value);

  if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
    return 1;
  }

  return Math.floor(parsedValue);
}

function build_package_label_code(baseCode, index, totalLabels) {
  const normalizedBaseCode = String(baseCode == null ? '' : baseCode).trim();

  if (!normalizedBaseCode) {
    return totalLabels > 1 ? `PACKAGE-${index + 1}` : 'PACKAGE';
  }

  return totalLabels > 1 ? `${normalizedBaseCode}-${index + 1}` : normalizedBaseCode;
}

function build_partner_storage_code(partnerCode, storageShortName) {
  const normalizedPartnerCode = String(partnerCode == null ? '' : partnerCode).trim();
  const normalizedStorageShortName = String(storageShortName == null ? '' : storageShortName).trim();

  if (!normalizedPartnerCode) {
    return normalizedStorageShortName;
  }

  if (!normalizedStorageShortName) {
    return normalizedPartnerCode;
  }

  if (normalizedPartnerCode.endsWith('.') || normalizedPartnerCode.endsWith('-')) {
    return `${normalizedPartnerCode}${normalizedStorageShortName}`;
  }

  return `${normalizedPartnerCode}.${normalizedStorageShortName}`;
}

export function print_product_package_labels(product, packageItem, storage = {}) {
  const totalLabels = normalize_label_count(packageItem && packageItem.NumberOfPack);
  const baseCode = (packageItem && packageItem.TransactionCode) || (product && product.Code) || '';
  const partnerStorageCode = build_partner_storage_code(
    product && product.PartnerName,
    storage && (storage.ShortName || storage.shortname)
  );
  const packageWeight = packageItem && packageItem.Weight ? currency(packageItem.Weight, '', 1) : '';
  const packageSize = [packageItem && packageItem.Length, packageItem && packageItem.Width, packageItem && packageItem.Height]
    .map(value => Number(value) || 0)
    .filter(value => value > 0)
    .join(' x ');
  const labels = Array.from({ length: totalLabels }, function(_, index) {
    const trackingCode = build_package_label_code(baseCode, index, totalLabels);

    return {
      trackingCode,
      partnerStorageCode,
      qrValue: trackingCode,
      packageOrder: totalLabels > 1 ? `Kiện ${index + 1}/${totalLabels}` : '',
      packageSize: packageSize ? `${packageSize} cm` : '',
      packageWeight: packageWeight ? `${packageWeight} kg` : '',
    };
  });
  const printWindow = window.open('', 'PRINT_PACKAGE_LABELS', 'height=900,width=720');

  if (!printWindow) {
    return false;
  }

  const labelsHtml = labels.map(function(label) {
    return `<section class="label">
      <div class="label-top">
        <svg class="barcode" data-barcode-value="${escape_label_html(label.trackingCode)}"></svg>
        <div class="tracking-code">${escape_label_html(label.trackingCode)}</div>
      </div>
      <div class="label-middle">${escape_label_html(label.partnerStorageCode)}</div>
      <div class="label-bottom">
        <canvas class="qr-code" data-qr-value="${escape_label_html(label.qrValue)}"></canvas>
        <div class="label-meta">
          <div class="label-meta-line">${escape_label_html(label.packageOrder)}</div>
          <div class="label-meta-line">${escape_label_html(label.packageSize)}</div>
          <div class="label-meta-line">${escape_label_html(label.packageWeight)}</div>
        </div>
      </div>
    </section>`;
  }).join('');

  const printContent = `<!DOCTYPE html>
  <html>
    <head>
      <title>In tem kiện hàng</title>
      <meta charset="utf-8">
      <style>
        @page {
          size: 6cm 5cm;
          margin: 0;
        }

        * {
          box-sizing: border-box;
        }

        html, body {
          margin: 0;
          padding: 0;
          background: #fff;
          font-family: Arial, sans-serif;
          color: #111;
        }

        body {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .label {
          width: 6cm;
          height: 5cm;
          padding: 0.12cm 0.14cm;
          border: 1px solid #000;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          page-break-after: always;
          overflow: hidden;
        }

        .label:last-child {
          page-break-after: auto;
        }

        .label-top {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 1.4cm;
          border-bottom: 1px solid #000;
          padding-bottom: 0.05cm;
        }

        .barcode {
          width: 100%;
          height: 0.9cm;
        }

        .tracking-code {
          margin-top: 0.02cm;
          font-size: 0.42cm;
          font-weight: 700;
          letter-spacing: 0.02cm;
          text-align: center;
          line-height: 1;
        }

        .label-middle {
          margin-top: 0.08cm;
          padding: 0.08cm 0.12cm;
          border: 1px solid #000;
          font-size: 0.54cm;
          font-weight: 700;
          text-align: center;
          line-height: 1.1;
          min-height: 0.82cm;
          display: flex;
          align-items: center;
          justify-content: center;
          word-break: break-word;
        }

        .label-bottom {
          margin-top: 0.08cm;
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 1.8cm;
        }

        .qr-code {
          width: 1.25cm;
          height: 1.25cm;
          flex: none;
          display: block;
        }

        .label-meta {
          flex: none;
          min-width: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 0.03cm;
          margin-top: 0.06cm;
        }

        .label-meta-line {
          font-size: 0.25cm;
          line-height: 1.2;
          word-break: break-word;
          text-align: center;
        }
      </style>
      <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/qrious@4.0.2/dist/qrious.min.js"></script>
    </head>
    <body>
      ${labelsHtml}
      <script>
        (function() {
          function renderLabels() {
            var barcodeNodes = document.querySelectorAll('.barcode');
            var qrNodes = document.querySelectorAll('.qr-code');

            barcodeNodes.forEach(function(node) {
              var value = node.getAttribute('data-barcode-value') || '';
              JsBarcode(node, value, {
                format: 'CODE128',
                displayValue: false,
                margin: 0,
                width: 1.25,
                height: 26
              });
            });

            qrNodes.forEach(function(node) {
              var value = node.getAttribute('data-qr-value') || '';

              new QRious({
                element: node,
                value: value,
                size: 78,
                level: 'M'
              });
            });

            window.setTimeout(function() {
              window.focus();
              window.print();
            }, 300);
          }

          if (document.readyState === 'complete') {
            renderLabels();
          } else {
            window.addEventListener('load', renderLabels);
          }

          window.onafterprint = function() {
            window.close();
          };
        })();
      <\/script>
    </body>
  </html>`;

  printWindow.document.open();
  printWindow.document.write(printContent);
  printWindow.document.close();
  return true;
}

export function print_transaction(weight, transactionCode, customerName, orderId) {
  var mywindow = window.open("", "PRINT");

  mywindow.document.write("<html><head><title></title>");
  mywindow.document.write(
    "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
  );
  mywindow.document.write(
    ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
  );
  mywindow.document.write(
    ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 14px; font-weight: bold; font-style: italic; text-align: center;}"
  );
  mywindow.document.write(
    "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
  );
  mywindow.document.write("<div class='layout wrap'>");
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${customerName}</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><hr class='v-divider theme--light'></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${orderId}</p></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${weight} kg</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Mã vận đơn</p></div><div class='flex lg6'><p class='sub-title r-text'>${transactionCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
      new Date()
    ).format("DD-MM-YYYY")}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Lưu ý</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Qúy khách khi bóc hàng vui lòng giữ lại mã vận đơn Trung Quốc để sử dụng trong trường hợp Khiếu nại với nhà cung cấp</p></div>`
  );
  mywindow.document.write(`<hr class='v-divider theme--light'>`);
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>https://csimex.vn</p></div>`
  );
  mywindow.document.write("</div>");
  mywindow.document.write("</body></html>");

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  mywindow.close();
  return true;
}
export function print_quote_label(item) {
  const print_content = `<html>
  <head>
    <title></title>
    <style>
      .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } 
      .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 20px; font-weight: bold; } 
      .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 11px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 13px; } 
      table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } 
      tr, td, th { page-break-inside: avoid !important; height: 20px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } 
      body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 60px;} .width-volumn {width: 50px;}
    </style>
  </head>
  
  <body style='width:80mm;font-family: Roboto,sans-serif;'>
    <div class='layout wrap'>
      <table>
        <tr>
          <td class='no-boder body-text'>Product Name: ${item.ProductName}</td>
        </tr>	
        <tr>
          <td class='no-boder body-text'>Manufacturer: ${item.Manufacturer || ''}</td>
        </tr>
        <tr>
          <td class='no-boder body-text'>Address: ${item.ManufacturerAddress || ''}</td>
        </tr>
        <tr>
          <td class='no-boder body-text'>Code: ${item.LabelCode || ''}</td>
        </tr>
        <tr>
          <td class='no-boder body-text'>Date: ${item.LabelDate || ''}</td>
        </tr>
        <tr>
          <td class='no-boder body-text'>MADE IN CHINA</td>
        </tr>
        <tr>
          <td class='no-boder sub-title m-text'>${item.Username} - ${item.NumberOfPack}</td>
        </tr>
      </table>
      </div>
  </body>
</html>`;

  var doc = document.getElementById('print_frame').contentWindow.document;
  doc.open();
  doc.write(print_content);
  doc.close();
  setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
}

export function print_item_package_labels(item, storage = {}) {
  // item is expected to be the quote/product object containing a Packages JSON string
  let packages = [];
  try {
    packages = item && item.Packages ? JSON.parse(item.Packages) : [];
  } catch (e) {
    packages = [];
  }

  const resolvedStorage = storage && Object.keys(storage).length ? storage : (config && config.LOCATION_STORE ? (config.LOCATION_STORE.find(s => s.value === item.StoreID) || {}) : {});

  if (!packages || packages.length === 0) {
    // No packages found — nothing to print as package labels
    return false;
  }

  // Build all labels for all packages into a single array, then print in one window
  const partnerStorageCode = build_partner_storage_code(
    item && item.PartnerName,
    resolvedStorage && (resolvedStorage.ShortName || resolvedStorage.shortname)
  );

  const allLabels = [];
  packages.forEach(function(pkg) {
    const totalLabels = normalize_label_count(pkg && pkg.NumberOfPack);
    const baseCode = (pkg && pkg.TransactionCode) || (item && item.Code) || '';
    const packageWeight = pkg && pkg.Weight ? currency(pkg.Weight, '', 1) : '';
    const packageSize = [pkg && pkg.Length, pkg && pkg.Width, pkg && pkg.Height]
      .map(function(value) { return Number(value) || 0; })
      .filter(function(value) { return value > 0; })
      .join(' x ');

    for (var i = 0; i < totalLabels; i++) {
      const trackingCode = build_package_label_code(baseCode, i, totalLabels);
      allLabels.push({
        trackingCode: trackingCode,
        partnerStorageCode: partnerStorageCode,
        qrValue: trackingCode,
        packageOrder: totalLabels > 1 ? ('Kiện ' + (i + 1) + '/' + totalLabels) : '',
        packageSize: packageSize ? (packageSize + ' cm') : '',
        packageWeight: packageWeight ? (packageWeight + ' kg') : '',
      });
    }
  });

  if (allLabels.length === 0) {
    return false;
  }

  const printWindow = window.open('', 'PRINT_PACKAGE_LABELS', 'height=900,width=720');

  if (!printWindow) {
    return false;
  }

  const labelsHtml = allLabels.map(function(label) {
    return '<section class="label">\n' +
      '      <div class="label-top">\n' +
      '        <svg class="barcode" data-barcode-value="' + escape_label_html(label.trackingCode) + '"></svg>\n' +
      '        <div class="tracking-code">' + escape_label_html(label.trackingCode) + '</div>\n' +
      '      </div>\n' +
      '      <div class="label-middle">' + escape_label_html(label.partnerStorageCode) + '</div>\n' +
      '      <div class="label-bottom">\n' +
      '        <canvas class="qr-code" data-qr-value="' + escape_label_html(label.qrValue) + '"></canvas>\n' +
      '        <div class="label-meta">\n' +
      '          <div class="label-meta-line">' + escape_label_html(label.packageOrder) + '</div>\n' +
      '          <div class="label-meta-line">' + escape_label_html(label.packageSize) + '</div>\n' +
      '          <div class="label-meta-line">' + escape_label_html(label.packageWeight) + '</div>\n' +
      '        </div>\n' +
      '      </div>\n' +
      '    </section>';
  }).join('');

  const printContent = `<!DOCTYPE html>
  <html>
    <head>
      <title>In tem kiện hàng</title>
      <meta charset="utf-8">
      <style>
        @page {
          size: 6cm 5cm;
          margin: 0;
        }

        * {
          box-sizing: border-box;
        }

        html, body {
          margin: 0;
          padding: 0;
          background: #fff;
          font-family: Arial, sans-serif;
          color: #111;
        }

        body {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .label {
          width: 6cm;
          height: 5cm;
          padding: 0.12cm 0.14cm;
          border: 1px solid #000;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          page-break-after: always;
          overflow: hidden;
        }

        .label:last-child {
          page-break-after: auto;
        }

        .label-top {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 1.4cm;
          border-bottom: 1px solid #000;
          padding-bottom: 0.05cm;
        }

        .barcode {
          width: 100%;
          height: 0.9cm;
        }

        .tracking-code {
          margin-top: 0.02cm;
          font-size: 0.42cm;
          font-weight: 700;
          letter-spacing: 0.02cm;
          text-align: center;
          line-height: 1;
        }

        .label-middle {
          margin-top: 0.08cm;
          padding: 0.08cm 0.12cm;
          border: 1px solid #000;
          font-size: 0.54cm;
          font-weight: 700;
          text-align: center;
          line-height: 1.1;
          min-height: 0.82cm;
          display: flex;
          align-items: center;
          justify-content: center;
          word-break: break-word;
        }

        .label-bottom {
          margin-top: 0.08cm;
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 1.8cm;
        }

        .qr-code {
          width: 1.25cm;
          height: 1.25cm;
          flex: none;
          display: block;
        }

        .label-meta {
          flex: none;
          min-width: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 0.03cm;
          margin-top: 0.06cm;
        }

        .label-meta-line {
          font-size: 0.25cm;
          line-height: 1.2;
          word-break: break-word;
          text-align: center;
        }
      </style>
      <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"><\/script>
      <script src="https://cdn.jsdelivr.net/npm/qrious@4.0.2/dist/qrious.min.js"><\/script>
    </head>
    <body>
      ${labelsHtml}
      <script>
        (function() {
          function renderLabels() {
            var barcodeNodes = document.querySelectorAll('.barcode');
            var qrNodes = document.querySelectorAll('.qr-code');

            barcodeNodes.forEach(function(node) {
              var value = node.getAttribute('data-barcode-value') || '';
              JsBarcode(node, value, {
                format: 'CODE128',
                displayValue: false,
                margin: 0,
                width: 1.25,
                height: 26
              });
            });

            qrNodes.forEach(function(node) {
              var value = node.getAttribute('data-qr-value') || '';

              new QRious({
                element: node,
                value: value,
                size: 78,
                level: 'M'
              });
            });

            window.setTimeout(function() {
              window.focus();
              window.print();
            }, 300);
          }

          if (document.readyState === 'complete') {
            renderLabels();
          } else {
            window.addEventListener('load', renderLabels);
          }

          window.onafterprint = function() {
            window.close();
          };
        })();
      <\/script>
    </body>
  </html>`;

  printWindow.document.open();
  printWindow.document.write(printContent);
  printWindow.document.close();
  return true;
}
export function print_quote(item, products = []) {
  const print_content = `<html>
  <head>
    <title>Báo giá #${item.ID}</title>
    <style>
      body { 
        font-family: 'Times New Roman', serif; 
        margin: 0; 
        padding: 20px; 
        font-size: 14px; 
        line-height: 1.4;
        color: #333;
      }
      .header {
        text-align: center;
        margin-bottom: 30px;
        border-bottom: 2px solid #2196F3;
        padding-bottom: 20px;
      }
      .company-name {
        font-size: 24px;
        font-weight: bold;
        color: #2196F3;
        margin-bottom: 5px;
      }
      .company-info {
        font-size: 12px;
        color: #666;
        margin-bottom: 10px;
      }
      .quote-title {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        margin-top: 15px;
      }
      .quote-number {
        font-size: 16px;
        color: #666;
        margin-top: 5px;
      }
      
      .customer-section {
        margin-bottom: 25px;
        background: #f8f9fa;
        padding: 15px;
        border-radius: 5px;
      }
      .section-title {
        font-size: 16px;
        font-weight: bold;
        color: #2196F3;
        margin-bottom: 10px;
        border-bottom: 1px solid #ddd;
        padding-bottom: 5px;
      }
      .info-row {
        display: flex;
        margin-bottom: 8px;
      }
      .info-label {
        font-weight: bold;
        width: 180px;
        color: #555;
      }
      .info-value {
        flex: 1;
        color: #333;
      }
      
      .quote-details {
        margin-bottom: 25px;
      }
      .details-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      .details-table th {
        background: #2196F3;
        color: white;
        padding: 12px 8px;
        text-align: left;
        font-weight: bold;
        border: 1px solid #1976D2;
      }
      .details-table td {
        padding: 10px 8px;
        border: 1px solid #ddd;
        background: white;
        vertical-align: middle;
      }
      .details-table tr:nth-child(even) td {
        background: #f8f9fa;
      }
      .details-table img {
        display: block;
        margin: 0 auto;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      .image-cell {
        text-align: center;
        vertical-align: middle;
        padding: 8px;
        min-height: 70px;
      }
      .number-cell {
        text-align: right;
        font-family: 'Courier New', monospace;
        font-weight: bold;
      }
      .highlight-row {
        background: #e3f2fd !important;
        font-weight: bold;
      }
      
      .summary-section {
        margin-top: 25px;
        border: 2px solid #2196F3;
        border-radius: 5px;
        overflow: hidden;
      }
      .summary-header {
        background: #2196F3;
        color: white;
        padding: 12px;
        font-weight: bold;
        font-size: 16px;
      }
      .summary-content {
        padding: 15px;
        background: white;
      }
      .summary-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        padding: 5px 0;
      }
      .summary-label {
        font-weight: bold;
        color: #555;
      }
      .summary-value {
        font-family: 'Courier New', monospace;
        font-weight: bold;
        color: #333;
      }
      .total-row {
        border-top: 2px solid #2196F3;
        margin-top: 10px;
        padding-top: 10px;
        font-size: 16px;
      }
      .total-row .summary-value {
        color: #2196F3;
        font-size: 18px;
      }
      
      .notes-section {
        margin-top: 25px;
        background: #fff3cd;
        border: 1px solid #ffeaa7;
        border-radius: 5px;
        padding: 15px;
      }
      .notes-title {
        font-weight: bold;
        color: #856404;
        margin-bottom: 10px;
      }
      .notes-content {
        color: #856404;
        font-style: italic;
      }
      
      .footer {
        margin-top: 40px;
        text-align: center;
        border-top: 1px solid #ddd;
        padding-top: 20px;
        color: #666;
        font-size: 12px;
      }
      .signature-section {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
      }
      .signature-box {
        width: 200px;
        text-align: center;
      }
      .signature-line {
        border-bottom: 1px solid #333;
        height: 60px;
        margin-bottom: 5px;
      }
      
      @media print {
        @page { 
          size: A4; 
          margin: 15mm; 
        }
        body { 
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }
        .no-print { 
          display: none; 
        }
      }
      
      .currency {
        font-family: 'Courier New', monospace;
      }
      .status-badge {
        display: inline-block;
        padding: 4px 8px;
        border-radius: 3px;
        font-size: 12px;
        font-weight: bold;
      }
      .status-quoted {
        background: #d4edda;
        color: #155724;
      }
      .status-pending {
        background: #fff3cd;
        color: #856404;
      }
    </style>
  </head>
  
  <body>
    <!-- Header -->
    <div class="header">
      <div class="company-name">THP GLOBAL</div>
      <div class="company-info">
        Dịch vụ vận chuyển hàng hóa Trung Quốc - Việt Nam<br>
        Điện thoại: 0945 423 888 | Email: chausalog@gmail.com<br>
        Website: https://csimex.vn
      </div>
      <div class="quote-title">BÁO GIÁ DỊCH VỤ VẬN CHUYỂN</div>
      <div class="info-row" style="justify-content: space-between; display: flex; margin-top: 15px;">
        <div>
          <span style="font-weight: bold; color: #555;">Mã khai báo: </span>
          <span>#${item.ID || 'N/A'}</span>
        </div>
        <div>
          <span style="font-weight: bold; color: #555;">Trạng thái: </span>
          <span class="status-badge ${item.IsQuoted ? 'status-quoted' : 'status-pending'}">
            ${item.IsQuoted ? 'Đã khai báo' : 'Chưa khai báo'}
          </span>
        </div>
      </div>
    </div>

    <!-- Customer Information -->
    <div class="customer-section">
      <div class="section-title">THÔNG TIN KHÁCH HÀNG</div>
      <div class="info-row">
        <div class="info-label">Mã khách hàng:</div>
        <div class="info-value">${item.UID || 'N/A'}</div>
      </div>
      <div class="info-row">
        <div class="info-label">Tên khách hàng:</div>
        <div class="info-value">${item.Username || item.CustomerName || 'N/A'}</div>
      </div>
      <div class="info-row">
        <div class="info-label">Ngày tạo khai báo:</div>
        <div class="info-value">${moment().format('DD/MM/YYYY HH:mm')}</div>
      </div>
    </div>

    <!-- Product Information -->
    <div class="quote-details">
      <div class="section-title">THÔNG TIN HÀNG HÓA</div>
      <table class="details-table">
        <tr>
          <th style="width: 25%">Tên loại hàng</th>
          <th style="width: 15%">Mã HS</th>
          <th style="width: 15%">Số sản phẩm</th>
          <th style="width: 15%">Số kiện</th>
          <th style="width: 15%">Cân nặng (kg)</th>
          <th style="width: 15%">Thể tích (m³)</th>
          <th style="width: 15%">Hình ảnh</th>
        </tr>
        ${item.Packages && item.Packages.length > 0 ? 
          item.Packages.map((pkg, index) => `
        <tr>
          <td>${pkg.ProductInfo || 'N/A'}</td>
          ${index === 0 ? `
          <td rowspan="${item.Packages.length}">${item.HsCode || 'N/A'}</td>
          <td rowspan="${item.Packages.length}" class="number-cell">${currency(item.ProductNumber || 0, '', 0)}</td>
          <td rowspan="${item.Packages.length}" class="number-cell">${currency(item.NumberOfPack || 0, '', 0)}</td>
          <td rowspan="${item.Packages.length}" class="number-cell">${currency(item.Weight || 0, '', 1)}</td>
          <td rowspan="${item.Packages.length}" class="number-cell">${currency(item.Volume || 0, '', 3)}</td>
          <td rowspan="${item.Packages.length}" style="text-align: center; padding: 8px;">
            ${item.ImageUrl ? 
              `<img src="${item.ImageUrl}" style="max-width: 80px; max-height: 60px; object-fit: contain; border-radius: 4px; border: 1px solid #ddd;" onerror="this.style.display='none'; this.nextElementSibling.style.display='inline';" />
               <span style="display: none; color: #666; font-style: italic;">Lỗi tải ảnh</span>` 
              : '<span style="color: #999; font-style: italic;">Không có ảnh</span>'
            }
          </td>
          ` : ''}
        </tr>
          `).join('')
        : `
        <tr>
          <td>N/A</td>
          <td>${item.HsCode || 'N/A'}</td>
          <td class="number-cell">${currency(item.ProductNumber || 0, '', 0)}</td>
          <td class="number-cell">${currency(item.NumberOfPack || 0, '', 0)}</td>
          <td class="number-cell">${currency(item.Weight || 0, '', 1)}</td>
          <td class="number-cell">${currency(item.Volume || 0, '', 3)}</td>
          <td style="text-align: center; padding: 8px;">
            ${item.ImageUrl ? 
              `<img src="${item.ImageUrl}" style="max-width: 80px; max-height: 60px; object-fit: contain; border-radius: 4px; border: 1px solid #ddd;" onerror="this.style.display='none'; this.nextElementSibling.style.display='inline';" />
               <span style="display: none; color: #666; font-style: italic;">Lỗi tải ảnh</span>` 
              : '<span style="color: #999; font-style: italic;">Không có ảnh</span>'
            }
          </td>
        </tr>
        `}
      </table>
    </div>

    <!-- Detailed Products List -->
    ${products && products.length > 0 ? `
    <div class="quote-details">
      <div class="section-title">CHI TIẾT CÁC SẢN PHẨM TRONG BÁO GIÁ</div>
      <table class="details-table">
        <tr>
          <th style="width: 8%">STT</th>
          <th style="width: 20%">Tên sản phẩm</th>
          <th style="width: 12%">Mã HS</th>
          <th style="width: 10%">Số lượng</th>
          <th style="width: 10%">Cân nặng (kg)</th>
          <th style="width: 10%">Thể tích (m³)</th>
          <th style="width: 12%">Đơn giá (CNY)</th>
          <th style="width: 18%">Hình ảnh</th>
        </tr>
        ${products.map((product, index) => `
        <tr>
          <td class="number-cell">${index + 1}</td>
          <td>${product.ProductInfo || 'N/A'}</td>
          <td>${product.HsCode || 'N/A'}</td>
          <td class="number-cell">${currency(product.NumberOfPack || 0, '', 0)}</td>
          <td class="number-cell">${currency(product.Weight || 0, '', 1)}</td>
          <td class="number-cell">${currency(product.Volume || 0, '', 3)}</td>
          <td class="number-cell currency">${currency(product.UnitPrice || 0, '', 2)} CNY</td>
          <td class="image-cell">
            ${product.ImageUrl ? 
              `<img src="${product.ImageUrl}" alt="${product.ProductInfo}" 
                   style="max-width: 80px; max-height: 60px; object-fit: contain; border-radius: 4px; border: 1px solid #ddd;" 
                   onerror="this.style.display='none'; this.nextElementSibling.style.display='inline';" />
               <span style="display: none; color: #666; font-style: italic;">Lỗi tải ảnh</span>` 
              : '<span style="color: #999; font-style: italic;">Không có ảnh</span>'
            }
          </td>
        </tr>
        `).join('')}
      </table>
    </div>
    ` : ''}

    <!-- Pricing Details -->
    <div class="quote-details">
      <div class="section-title">CHI TIẾT GIÁ DỊCH VỤ</div>
      <table class="details-table">
        <tr>
          <th style="width: 50%">Nội dung</th>
          <th style="width: 20%">Đơn giá</th>
          <th style="width: 15%">Tỷ lệ (%)</th>
          <th style="width: 15%">Thành tiền</th>
        </tr>
        <tr>
          <td>Giá cần khai báo</td>
          <td class="number-cell currency">${currency(item.CustomsPriceVND || 0, '', 0)} VND</td>
          <td class="number-cell">-</td>
          <td class="number-cell currency">${currency(item.CustomsAmountVND || 0, '', 0)} VND</td>
        </tr>
        <tr>
          <td>Thuế nhập khẩu</td>
          <td class="number-cell">-</td>
          <td class="number-cell">${currency(item.ImportTax || 0, '', 2)}%</td>
          <td class="number-cell currency">${currency((item.CustomsAmountVND || 0) * (item.ImportTax || 0) / 100, '', 0)} VND</td>
        </tr>
        <tr>
          <td>Thuế VAT</td>
          <td class="number-cell">-</td>
          <td class="number-cell">${currency(item.VatTax || 0, '', 2)}%</td>
          <td class="number-cell currency">${currency((item.CustomsAmountVND || 0) * (item.VatTax || 0) / 100, '', 0)} VND</td>
        </tr>
        <tr>
          <td>Phí dịch vụ</td>
          <td class="number-cell">-</td>
          <td class="number-cell">${currency(item.ServiceFee || 0, '', 2)}%</td>
          <td class="number-cell currency">${currency((item.CustomsAmountVND || 0) * (item.ServiceFee || 0) / 100, '', 0)} VND</td>
        </tr>
        <tr>
          <td>Chi phí ngoài</td>
          <td class="number-cell">-</td>
          <td class="number-cell">-</td>
          <td class="number-cell currency">${currency(item.OtherFeeAmount || 0, '', 0)} VND</td>
        </tr>
        <tr>
          <td>Tổng phí dịch vụ</td>
          <td class="number-cell">-</td>
          <td class="number-cell">-</td>
          <td class="number-cell currency">${currency(item.TotalFeeAmount || 0, '', 0)} VND</td>
        </tr>
        <tr>
          <td>Giá vận chuyển theo cân (kg)</td>
          <td class="number-cell currency">${currency(item.WeightPrice || 0, '', 0)} VND</td>
          <td class="number-cell">-</td>
          <td class="number-cell currency">${currency((item.Weight || 0) * (item.WeightPrice || 0), '', 0)} VND</td>
        </tr>
        <tr>
          <td>Giá vận chuyển theo thể tích (m³)</td>
          <td class="number-cell currency">${currency(item.VolumePrice || 0, '', 0)} VND</td>
          <td class="number-cell">-</td>
          <td class="number-cell currency">${currency((item.Volume || 0) * (item.VolumePrice || 0), '', 0)} VND</td>
        </tr>
        <tr>
          <td>Phí vận chuyển dự kiến TQ-VN</td>
          <td class="number-cell currency">${currency(item.EstimateTransitPrice || 0, '', 0)} VND</td>
          <td class="number-cell">-</td>
          <td class="number-cell currency">${currency(item.EstimateTransitAmount || 0, '', 0)} VND</td>
        </tr>
      </table>
    </div>

    <!-- Summary -->
    <div class="summary-section">
      <div class="summary-header">TỔNG KẾT CHI PHÍ</div>
      <div class="summary-content">
        <div class="summary-row">
          <div class="summary-label">Tổng tiền khai báo hải quan:</div>
          <div class="summary-value currency">${currency(item.CustomsAmountVND || 0, '', 0)} VND</div>
        </div>
        <div class="summary-row">
          <div class="summary-label">Tổng các loại thuế và phí:</div>
          <div class="summary-value currency">${currency(item.TotalFeeAmount || 0, '', 0)} VND</div>
        </div>
        <div class="summary-row">
          <div class="summary-label">Tổng phí vận chuyển dự kiến:</div>
          <div class="summary-value currency">${currency(item.EstimateTransitAmount || 0, '', 0)} VND</div>
        </div>
        <div class="summary-row total-row">
          <div class="summary-label">TỔNG CỘNG:</div>
          <div class="summary-value currency">${currency(item.TotalAmount || 0, '', 0)} VND</div>
        </div>
        <div class="summary-row">
          <div class="summary-label">Đã thanh toán:</div>
          <div class="summary-value currency">${currency(item.PaidAmount || 0, '', 0)} VND</div>
        </div>
        <div class="summary-row">
          <div class="summary-label">Còn lại:</div>
          <div class="summary-value currency">${currency((item.TotalAmount || 0) - (item.PaidAmount || 0), '', 0)} VND</div>
        </div>
      </div>
    </div>

    <!-- Notes -->
    <div class="notes-section">
      <div class="notes-title">GHI CHÚ QUAN TRỌNG:</div>
      <div class="notes-content">
        • Báo giá này có hiệu lực trong vòng 7 ngày kể từ ngày lập.<br>
        • Giá trên chưa bao gồm các phí phát sinh khác (nếu có).<br>
        • Tỷ giá có thể thay đổi theo thời gian thực.<br>
        • Thuế và phí có thể thay đổi theo quy định của cơ quan hải quan.<br>
        • Quý khách vui lòng xác nhận khai báo trước khi tiến hành giao dịch.<br>
        • Mọi thắc mắc xin liên hệ hotline: 0945 423 888
      </div>
    </div>

    <!-- Signatures -->
    <div class="signature-section">
      <div class="signature-box">
        <div class="signature-line"></div>
        <div><strong>Người lập khai báo</strong></div>
        <div><em>(Ký và ghi rõ họ tên)</em></div>
      </div>
      <div class="signature-box">
        <div class="signature-line"></div>
        <div><strong>Khách hàng xác nhận</strong></div>
        <div><em>(Ký và ghi rõ họ tên)</em></div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer">
      <div>Cảm ơn Quý khách đã tin tưởng sử dụng dịch vụ của THP GLOBAL</div>
      <div>Báo giá được tạo tự động vào lúc ${moment().format('DD/MM/YYYY HH:mm:ss')}</div>
    </div>
  </body>
</html>`;

  // Create and open print window
  var printWindow = window.open('', 'PRINT', 'height=800,width=1200');
  
  printWindow.document.write(print_content);
  // printWindow.document.close();
  
  // Wait for content to load then print
  // setTimeout(function() {
  //   printWindow.focus();
  //   printWindow.print();
  //   printWindow.close();
  // }, 1000);
  
  return true;
}

export function print_export_receipt(item, packages) {
  // Tính tổng
  let totalPacks = 0;
  let totalWeight = 0;
  let totalVolume = 0;
  let totalAmount = 0;
  let totalFeeWeight = 0;
  let totalDiscount = 0;
  let totalLineAmount = 0;
  let totalTax = 0;
  let totalOtherFees = 0;

  let html_packages = ''
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];
    const taxAmount = (p.ImportTaxAmount || 0) + (p.VatTaxAmount || 0) + (p.ServiceFeeAmount || 0);
    const otherFees = (p.TransactionDeposit || 0) + (p.PedicabDeposit || 0) + (p.LoadDeposit || 0) + (p.FeeCare || 0);
    
    totalPacks += p.NumberOfPack || 0;
    totalWeight += p.Weight || 0;
    totalVolume += p.Volume || 0;
    totalAmount += p.Amount || 0;
    totalFeeWeight += p.TotalFeeWeight || 0;
    totalDiscount += p.DiscountAmount || 0;
    totalLineAmount += p.LineAmount || 0;
    totalTax += taxAmount;
    totalOtherFees += otherFees;

    html_packages = html_packages + `<tr>
                        <td class='body-text text-center'>${i+1}</td>
                        <td class='body-text'>${p.ProductNameCN || ''}</td>
                        <td class='body-text text-right'>${currency(p.NumberOfPack || 0,'',0)}</td>
                        <td class='body-text text-right'>${currency(p.Weight || 0,'',1)}</td>
                        <td class='body-text text-right'>${currency(p.Volume || 0,'',3)}</td>
                        <td class='body-text text-right'>${currency(p.WeightPrice || 0,'',0)}</td>
                        <td class='body-text text-right'>${currency(p.VolumePrice || 0,'',0)}</td>
                        <td class='body-text text-right'>${currency(p.TotalFeeWeight || 0,'',0)}</td>
                        <td class='body-text text-right small-text'>
                          <div>NK: ${currency(p.ImportTaxAmount || 0,'',0)}</div>
                          <div>VAT: ${currency(p.VatTaxAmount || 0,'',0)}</div>
                          <div>DV: ${currency(p.ServiceFeeAmount || 0,'',0)}</div>
                        </td>
                        <td class='body-text text-right small-text'>
                          <div>Ship: ${currency(p.TransactionDeposit || 0,'¥',0)}</div>
                          <div>Kéo: ${currency(p.PedicabDeposit || 0,'¥',0)}</div>
                          <div>Nâng: ${currency(p.LoadDeposit || 0,'¥',0)}</div>
                          <div>BH: ${currency(p.FeeCare || 0,'¥',0)}</div>
                        </td>
                        <td class='body-text text-right'>${currency((p.Amount || 0),'',0)}</td>
                        <td class='body-text text-right'>${currency((p.DiscountAmount || 0),'',0)}</td>
                        <td class='body-text text-right'>${currency((p.LineAmount || 0),'',0)}</td>
                        <td class='body-text small-text'>${p.Note || ''}</td>
                      </tr>`
  }

  const print_content = `<html>
  <head>
    <title>Phiếu xuất kho #${item.ID || ''}</title>
    <style>
      body { 
        font-family: 'Times New Roman', serif; 
        margin: 0; 
        padding: 15px; 
        font-size: 13px; 
        line-height: 1.4;
        color: #333;
      }
      
      .header {
        text-align: center;
        margin-bottom: 25px;
        border-bottom: 2px solid #2196F3;
        padding-bottom: 15px;
      }
      .company-name {
        font-size: 20px;
        font-weight: bold;
        color: #2196F3;
        margin-bottom: 5px;
      }
      .company-info {
        font-size: 11px;
        color: #666;
        margin-bottom: 10px;
      }
      .document-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-top: 10px;
      }
      .document-info {
        font-size: 12px;
        color: #666;
        margin-top: 5px;
      }
      
      .receipt-info {
        margin-bottom: 20px;
        background: #f8f9fa;
        padding: 12px;
        border-radius: 5px;
        border-left: 4px solid #2196F3;
      }
      .info-row {
        display: flex;
        margin-bottom: 6px;
      }
      .info-label {
        font-weight: bold;
        width: 140px;
        color: #555;
      }
      .info-value {
        flex: 1;
        color: #333;
      }
      
      .products-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        font-size: 11px;
      }
      .products-table th {
        background: #2196F3;
        color: white;
        padding: 8px 4px;
        text-align: center;
        font-weight: bold;
        border: 1px solid #1976D2;
        font-size: 10px;
      }
      .products-table td {
        padding: 6px 4px;
        border: 1px solid #ddd;
        vertical-align: top;
        background: white;
      }
      .products-table tr:nth-child(even) td {
        background: #f8f9fa;
      }
      
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .text-left { text-align: left; }
      
      .body-text { font-size: 11px; }
      .small-text { font-size: 9px; line-height: 1.3; }
      .small-text div { margin-bottom: 1px; padding: 1px 0; }
      .sub-title { font-size: 12px; font-weight: bold; }
      
      .summary-row {
        background: #e3f2fd !important;
        font-weight: bold;
      }
      .summary-row td {
        background: #e3f2fd !important;
        color: #1976D2;
        font-weight: bold;
      }
      
      .signature-section {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #ddd;
        padding-top: 20px;
      }
      .signature-box {
        width: 30%;
        text-align: center;
        padding: 10px;
      }
      .signature-title {
        font-weight: bold;
        margin-bottom: 40px;
        font-size: 12px;
      }
      .signature-note {
        font-size: 10px;
        font-style: italic;
        color: #666;
      }
      
      .footer {
        margin-top: 20px;
        text-align: center;
        border-top: 1px solid #ddd;
        padding-top: 10px;
        color: #666;
        font-size: 10px;
      }
      
      .no-border { border: 0px !important; }
      
      .col-stt { width: 4%; }
      .col-code { width: 9%; }
      .col-name { width: 18%; }
      .col-number { width: 7%; }
      .col-weight { width: 7%; }
      .col-volume { width: 7%; }
      .col-price { width: 7%; }
      .col-amount { width: 9%; }
      .col-tax { width: 11%; }
      .col-fees { width: 15%; }
      .col-total { width: 9%; }
      .col-note { width: 12%; }
      
      @media print {
        @page { 
          size: A4 landscape; 
          margin: 10mm; 
        }
        body { 
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }
        .no-print { 
          display: none; 
        }
      }
    </style>
  </head>
  
  <body>
    <!-- Header -->
    <div class="header">
      <div class="company-name">THP GLOBAL</div>
      <div class="company-info">
        Dịch vụ vận chuyển hàng hóa Trung Quốc - Việt Nam<br>
        Điện thoại: 0945 423 888 | Email: chausalog@gmail.com | Website: https://csimex.vn
      </div>
      <div class="document-title">PHIẾU XUẤT KHO</div>
      <div class="document-info">
        Mã phiếu: #${item.ID || 'N/A'} | Ngày ${moment().format('DD/MM/YYYY')} | Giờ: ${moment().format('HH:mm')}
      </div>
    </div>

    <!-- Receipt Information -->
    <div class="receipt-info">
      <div class="info-row">
        <div class="info-label">Người nhận hàng:</div>
        <div class="info-value">${item.ReceiveName || 'N/A'}</div>
      </div>
      <div class="info-row">
        <div class="info-label">Số điện thoại:</div>
        <div class="info-value">${item.ReceivePhone || 'N/A'}</div>
      </div>
      <div class="info-row">
        <div class="info-label">Địa chỉ nhận hàng:</div>
        <div class="info-value">${item.ReceiveAddress || 'N/A'}</div>
      </div>
      <div class="info-row">
        <div class="info-label">Mã bill:</div>
        <div class="info-value">${item.Code || 'N/A'}</div>
      </div>
    </div>

    <!-- Products Table -->
    <table class="products-table">
      <thead>
        <tr>
          <th class="col-stt">STT</th>
          <th class="col-name">Tên hàng</th>
          <th class="col-number">Số kiện</th>
          <th class="col-weight">Cân nặng (kg)</th>
          <th class="col-volume">Thể tích (m³)</th>
          <th class="col-price">Giá cân</th>
          <th class="col-price">Giá khối</th>
          <th class="col-amount">Phí vận chuyển</th>
          <th class="col-tax">Thuế & Phí</th>
          <th class="col-fees">Chi phí khác</th>
          <th class="col-total">Tổng tiền</th>
          <th class="col-total">Chiết khấu</th>
          <th class="col-total">Thành tiền</th>
          <th class="col-note">Ghi chú</th>
        </tr>
      </thead>
      <tbody>
        ${html_packages}
        <tr class="summary-row">
          <td class="text-center sub-title" colspan="2">TỔNG CỘNG</td>
          <td class="text-right sub-title">${currency(totalPacks,'',0)}</td>
          <td class="text-right sub-title">${currency(totalWeight,'',1)}</td>
          <td class="text-right sub-title">${currency(totalVolume,'',3)}</td>
          <td class="text-center sub-title">-</td>
          <td class="text-center sub-title">-</td>
          <td class="text-right sub-title">${currency(totalFeeWeight,'',0)}</td>
          <td class="text-right sub-title">${currency(totalTax,'',0)}</td>
          <td class="text-right sub-title">${currency(totalOtherFees,'',0)}</td>
          <td class="text-right sub-title">${currency(totalAmount,'',0)}</td>
          <td class="text-right sub-title">${currency(totalDiscount,'',0)}</td>
          <td class="text-right sub-title">${currency(totalLineAmount,'',0)}</td>
          <td class="text-center sub-title">-</td>
        </tr>
      </tbody>
    </table>

    <!-- Signatures -->
    <div class="signature-section">
      <div class="signature-box">
        <div class="signature-title">Người lập phiếu</div>
        <div class="signature-note">(Ký và ghi rõ họ tên)</div>
      </div>
      <div class="signature-box">
        <div class="signature-title">Lái xe vận chuyển</div>
        <div class="signature-note">(Ký và ghi rõ họ tên)</div>
      </div>
      <div class="signature-box">
        <div class="signature-title">Người nhận hàng</div>
        <div class="signature-note">(Ký và ghi rõ họ tên)</div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer">
      <div>Cảm ơn Quý khách đã tin tưởng sử dụng dịch vụ của THP GLOBAL</div>
      <div>Phiếu xuất kho được tạo tự động vào lúc ${moment().format('DD/MM/YYYY HH:mm:ss')}</div>
    </div>
  </body>
</html>`;

  var doc = document.getElementById('print_frame').contentWindow.document;
  doc.open();
  doc.write(print_content);
  doc.close();
  setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
}